"use client";

import { useBrandConfig } from "@/hooks/useBrandConfig";
import { useOrg } from "@/hooks/useOrg";
import { applyBrandStyles } from "@/utils/common/brandStyles";
import { useEffect } from "react";

/**
 * Uses existing useOrg + useBrandConfig hooks to sync org.details.brand to the
 * document and apply its styles. Renders inside OrgContextProvider so org brand
 * overrides the layout’s host-based default.
 */
export default function BrandSyncFromOrg() {
  const { ui } = useOrg();
  const { config } = useBrandConfig(ui.brand);

  useEffect(() => {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    root.dataset.brand = ui.brand;
    if (config) {
      applyBrandStyles(config);
      globalThis.dispatchEvent(new Event("brandChanged"));
      root.classList.add("brand-ready");
    }
  }, [ui.brand, config]);

  return null;
}
